<template>
    <svg xmlns="http://www.w3.org/2000/svg" :height="size" :width="size" :fill="color" viewBox="0 -960 960 960">
        <path d="M480-200 240-440l56-56 184 183 184-183 56 56-240 240Zm0-240L240-680l56-56 184 183 184-183 56 56-240 240Z"/>
    </svg>
</template>

<script>
  export default {
    name: 'IconBedTimeDown',
    props: {
       color: {
        type: String,
        default: "#F3F3F3",
       },
       size: {
        type: String,
        default: "1rem",
       },
    }
  }
</script>